<template>
  <tag :color="getColor()">{{ getDate() }}</tag>
</template>

<script>
import moment from 'moment'

export default {
  props: ['date', 'status', 'type'],
  methods: {
    getDate () {
      const format = this.type === 'datetime' ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'
      return this.date ? moment(this.date).format(format) : 'Без срока'
    },
    getColor () {
      if (!this.date) return 'default'
      if (!this.status) return 'default'
      if (this.status.id === 4) return 'default'
      if (this.status.completed) return 'default'

      const diff = moment(this.date).diff(moment(), 'days')

      if (diff < 2) return 'red'
      if (diff < 5) return 'gold'
      return 'default'
    }
  }
}
</script>

<style lang="less">

</style>
